// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3EOai","tab":"Tabs_tab__2nHsL","tabActive":"Tabs_tabActive__1vwY-"};